module.exports = __webpack_public_path__ + "img/chorando.dd10893a.png";